export const dateFromTimestamp = (timestamp) => {
  let dateObject = new Date(timestamp);

  let day = String(dateObject.getDate());//can be 1
  if (day.length < 2) {
    day = '0' + day;
  }

  let month = String(dateObject.getMonth() + 1);
  if (month.length < 2) {
    month = '0' + month;
  }

  let year = String(dateObject.getFullYear());
  year = year.substring(2);

  return day + '/' + month + '/' + year;
} 


export const timeFromTimestamp = (timestamp) => {
  let dateObject = new Date(timestamp);

  let hours = String(dateObject.getHours());
  if (hours.length < 2) {
    hours = '0' + hours;
  }

  let minutes = String(dateObject.getMinutes());
  if (minutes.length < 2) {
    minutes = '0' + minutes;
  }

  return hours + ':' + minutes;
} 


// WEBPACK FOOTER //
// ./src/utils/format.js